import axios from "axios";
import {
  applyBearerAuth,
  dispatchAuthUnauthorized,
  isAuthCredentialRequest,
  assertAuthTokenNotExpired,
} from "./authToken";
import { API_URL } from "../config";

const api = axios.create({
  baseURL: API_URL
});

api.interceptors.request.use(
  (config) => {
    if (!isAuthCredentialRequest(config?.url)) {
      assertAuthTokenNotExpired();
    }
    return applyBearerAuth(config);
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !isAuthCredentialRequest(url)) {
      dispatchAuthUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default api;
